import React from 'react'
import PropTypes from 'prop-types'
import { ErrorMessage } from 'secondstep-components'
import K8LessonsTable from 'components/K8LessonsTable'
import { UNIT_5 } from './constants'
import {
  DrawerContent,
  LessonTableWrapper,
  StyledReportsLoading,
} from './component.styles'

const K8Class = ({
  classDetailsReport,
  classLessonColTooltip,
  classMarkedDoneTooltip,
  classStatusColTooltip,
  filterOutUnit5,
  fixedTop,
  fixedView,
  hasError,
  HeaderComponent,
  headerProps,
  isFetchingClass,
  onlyBhuLessons,
  statusCode,
  variant,
}) => {
  if (hasError) {
    return <ErrorMessage statusCode={statusCode} />
  }

  if (!HeaderComponent || !headerProps) {
    console.error(
      'K8Class: HeaderComponent and headerProps are required. Please provide both props.',
      {
        HeaderComponent: HeaderComponent?.name || HeaderComponent,
        headerProps,
      },
    )
    return null
  }

  if (isFetchingClass) {
    return <StyledReportsLoading text={'Loading class...'} />
  }

  const rawLessons = classDetailsReport?.lessons
  let lessons
  if (onlyBhuLessons) {
    lessons = rawLessons?.filter(lesson => lesson.parent === UNIT_5)
  } else if (filterOutUnit5) {
    lessons = rawLessons?.filter(lesson => lesson.parent !== UNIT_5)
  } else {
    lessons = rawLessons
  }

  return (
    <>
      <HeaderComponent {...headerProps} />
      <DrawerContent fixedTop={fixedTop} fixedView={fixedView}>
        <LessonTableWrapper>
          {lessons?.length > 0 && (
            <K8LessonsTable
              lessons={lessons}
              lessonsTooltip={classLessonColTooltip}
              markedDoneTooltip={classMarkedDoneTooltip}
              statusTooltip={classStatusColTooltip}
              variant={variant}
            />
          )}
        </LessonTableWrapper>
      </DrawerContent>
    </>
  )
}

K8Class.propTypes = {
  HeaderComponent: PropTypes.elementType.isRequired,
  classDetailsReport: PropTypes.object,
  classLessonColTooltip: PropTypes.string,
  classMarkedDoneTooltip: PropTypes.string,
  classStatusColTooltip: PropTypes.string,
  filterOutUnit5: PropTypes.bool,
  fixedTop: PropTypes.bool,
  fixedView: PropTypes.bool,
  hasError: PropTypes.bool,
  headerProps: PropTypes.object.isRequired,
  isFetchingClass: PropTypes.bool,
  onlyBhuLessons: PropTypes.bool,
  statusCode: PropTypes.number,
  variant: PropTypes.oneOf(['default', 'tier2']),
}

export default K8Class
